import { create } from 'apisauce'
import loading from '@/store/loading'

const api = create({
    baseURL: `https://cache.cinemapi.com/gazetaweb/`,
})

api.axiosInstance.interceptors.request.use(config => {
    loading.commit('START_LOADING');
    return config
}, function (error) {
    loading.commit('FINISH_LOADING');
    return Promise.reject(error);
})

api.axiosInstance.interceptors.response.use(response => {
    loading.commit('FINISH_LOADING');
    return response;
}, function (error) {
    loading.commit('FINISH_LOADING');
    return Promise.reject(error);
});

export default api